/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox" v-show="!collapsed">
      诚创微信公众平台
    </div>
    <div class="logobox" v-show="collapsed"></div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
          <i :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menuList } from '../api/baseset'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    /* let res = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: 'el-icon-s-help',
          menuname: '基础管理',
          url: null,
          menus: [
            {
              menuid: 2,
              icon: 'el-icon-user',
              menuname: '患者档案',
              url: 'base/Patient',
              menus: null
            },
            {
              menuid: 3,
              icon: 'el-icon-first-aid-kit',
              menuname: '科室管理',
              url: 'base/Department',
              menus: null
            },
            {
              menuid: 4,
              icon: 'el-icon-s-custom',
              menuname: '医生管理',
              url: 'base/Doctor',
              menus: null
            }
          ]
        },
        {
          menuid: 33,
          icon: 'el-icon-notebook-2',
          menuname: '财务管理',
          url: null,
          menus: [
            {
              menuid: 34,
              icon: 'el-icon-shopping-cart-2',
              menuname: '交易订单',
              url: 'pay/Order',
              menus: null
            },
            {
              menuid: 35,
              icon: 'el-icon-notebook-2',
              menuname: '对账管理',
              url: 'pay/Statement',
              menus: null
            },
            {
              menuid: 36,
              icon: 'el-icon-sold-out',
              menuname: '退费管理',
              url: 'pay/Refund',
              menus: null
            }
          ]
        },
        {
          menuid: 40,
          icon: 'el-icon-document',
          menuname: '新闻管理',
          url: null,
          menus: [
            {
              menuid: 41,
              icon: 'el-icon-document',
              menuname: '新闻列表',
              url: 'news/articleList',
              menus: null
            },
            {
              menuid: 42,
              icon: 'el-icon-document',
              menuname: '添加新闻',
              url: 'news/article',
              menus: null,
            }
          ]
        },
        {
          menuid: 71,
          icon: 'el-icon-setting',
          menuname: '系统管理',
          url: null,
          menus: [
            {
              menuid: 72,
              icon: 'el-icon-user',
              menuname: '用户管理',
              url: 'system/user',
              menus: null
            },
            {
              menuid: 73,
              icon: 'el-icon-s-check',
              menuname: '角色管理',
              url: 'system/Role',
              menus: null
            },
            {
              menuid: 75,
              icon: 'el-icon-s-tools',
              menuname: '系统设置',
              url: 'system/Variable',
              menus: null
            },
            {
              menuid: 76,
              icon: 'el-icon-s-release',
              menuname: '权限管理',
              url: 'system/Permission',
              menus: null
            },
            {
              menuid: 77,
              icon: 'el-icon-tickets',
              menuname: '日志管理',
              url: 'system/log',
              menus: null
            }
          ]
        },
        {
          menuid: 150,
          icon: 'el-icon-pie-chart',
          menuname: '图表',
          url: null,
          menus: [
            {
              menuid: 159,
              icon: 'el-icon-s-data',
              menuname: '数据可视化',
              url: 'charts/statistics',
              menus: null
            }
          ]
        }
      ],
      msg: 'success'
    }
    this.allmenu = res.data */

    menuList().then(res => {
      this.allmenu = res.data
    })
    .catch(err => {
      this.$message.error('菜单加载失败，请稍后再试！')
    })

    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #0981fd;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue